// extracted by mini-css-extract-plugin
module.exports = {"cGatsbyBackground":"v_b","lFooter__inner":"v_bH","lFooter":"v_bJ","lFooter__menu":"v_bK","lFooter__menuSns":"v_bL","lFooter__copyright":"v_bM","animationMarquee":"v_d"};